<template>
  <div class="modal" data-backdrop="static" id="bsMediaPlanTargetSaveFormDialog" ref="bsMediaPlanTargetSaveFormDialog">
    <div class="modal-dialog modal-xl" role="document">
      <div class="modal-content viewDetails">
        <form name="saveMediaPlanTarget"
              :action="pUrls['saveMediaPlanTarget']"
              method="post" class="ajax-support show-waiting"
              data-ajax-support-csv="#ajaxModuleForm,#mediaPlanTargetListHeader,#mediaPlanTargetListBody,#campaignModuleSidebar">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span>
            </button>
            <h3 class="modal-title">{{ title }}</h3>
          </div>
          <div class="modal-body max-height bs3-padding-top-reset bs3-padding-bottom-reset overflow-y-hidden">

            <input type="hidden" name="dataForm.data.id" :value="data.id"/>

            <input type="hidden" name="src" :value="pSrc"/>
            <input type="hidden" name="srcId" :value="pSrcId"/>

            <div v-if="nbOfErrors > 0">
              <div class="bs3-padding text-center bs3-margin-left-minus15 bs3-margin-right-minus15 bg-danger">
                <span class="label label-danger">{{ nbOfErrors | error(pDictionary) }}</span>
              </div>
            </div>

            <div class="row scrollable-content scroll-y-xs noscroll-y-lg bs3-light-gray-bg" style="min-height: 80vh">
<!--              <div class="col-xs-2 bs3-padding-y full-height-lg noscroll-y-xs scroll-y-lg">-->
<!--                &lt;!&ndash;-->
<!--                 - NAME-->
<!--                <div :class="['form-group', {'has-error': hasFieldErrors('dataForm.data.name')}]">-->
<!--                  <div v-if="hasFieldErrors('dataForm.data.name')">-->
<!--                    <span v-for="error in getFieldErrors('dataForm.data.name')" class="help-block" :key="error">{{ error }}</span>-->
<!--                  </div>-->
<!--                  <label v-else for="mediaPlanTarget_Name">-->
<!--                    <span class="required">*</span> {{ pDictionary['dictionary.media.plan.target.name'] }}-->
<!--                  </label>-->
<!--                  <input type="text"-->
<!--                         id="mediaPlanTarget_Name"-->
<!--                         :name="'dataForm.data.name'"-->
<!--                         v-model="data.name"-->
<!--                         class="form-control"-->
<!--                         :placeholder="pDictionary['dictionary.media.plan.target.name.placeholder']"/>-->
<!--                </div>-->
<!--                -&ndash;&gt;-->
                <input type="hidden"
                       v-model="data.name"
                       name="dataForm.data.name"/>

<!--                &lt;!&ndash;-->
<!--                - MEDIA PLAN-->
<!--                &ndash;&gt;-->
<!--                <media-plan-select-->
<!--                    v-model="mediaPlanId"-->
<!--                         :p-currencies="pCurrencies" :p-language="pLanguage"-->
<!--                    :p-dictionary="pDictionary"-->
<!--                    :p-urls="pUrls"-->
<!--                    :p-error-list="pErrorList"-->
<!--                    :p-src="pSrc"-->
<!--                    :p-src-id="pSrcId"-->
<!--                    p-error-key="dataForm.data.mediaPlanRef"-->
<!--                    :p-required="true"-->
<!--                    p-input-name="dataForm.data.mediaPlanRef.id"-->
<!--                    p-select-container="#bsMediaPlanTargetSaveFormDialog"-->
<!--                    :p-disabled="true">-->
<!--                </media-plan-select>-->

<!--                &lt;!&ndash;-->
<!--                - MEASURE-->
<!--                <media-plan-target-measure-select-->
<!--                    v-model="data.measureTokenText"-->
<!--                         :p-currencies="pCurrencies" :p-language="pLanguage"-->
<!--                    :p-dictionary="pDictionary"-->
<!--                    :p-urls="pUrls"-->
<!--                    :p-error-list="pErrorList"-->
<!--                    :p-src="pSrc"-->
<!--                    :p-src-id="pSrcId"-->
<!--                    p-select-container="#bsMediaPlanTargetSaveFormDialog"-->
<!--                    p-input-name="dataForm.data.measureTokenText"-->
<!--                    p-error-key="dataForm.data.measureTokenText"-->
<!--                    :p-required="true">-->
<!--                </media-plan-target-measure-select>-->
<!--                -&ndash;&gt;-->

<!--                &lt;!&ndash;-->
<!--                - DIMENSION LEVEL 1-->
<!--                <media-plan-target-dimension-select-->
<!--                    v-model="data.dimensionLevel1TokenText"-->
<!--                         :p-currencies="pCurrencies" :p-language="pLanguage"-->
<!--                    :p-dictionary="pDictionary"-->
<!--                    :p-urls="pUrls"-->
<!--                    :p-error-list="pErrorList"-->
<!--                    :p-src="pSrc"-->
<!--                    :p-src-id="pSrcId"-->
<!--                    p-select-container="#bsMediaPlanTargetSaveFormDialog"-->
<!--                    p-dictionary-key-label="dictionary.media.plan.target.dimension.level1"-->
<!--                    p-input-name="dataForm.data.dimensionLevel1TokenText"-->
<!--                    p-error-key="dataForm.data.dimensionLevel1TokenText"-->
<!--                    :p-required="true">-->
<!--                </media-plan-target-dimension-select>-->
<!--                -&ndash;&gt;-->
                <input type="hidden"
                       v-model="data.dimensionLevel1TokenText"
                       name="dataForm.data.dimensionLevel1TokenText"/>

<!--                &lt;!&ndash;-->
<!--                - TIMELINE-->
<!--                -&ndash;&gt;-->
<!--                <media-plan-target-timeline-select-->
<!--                    v-model="data.timelineText"-->
<!--                         :p-currencies="pCurrencies" :p-language="pLanguage"-->
<!--                    :p-dictionary="pDictionary"-->
<!--                    :p-urls="pUrls"-->
<!--                    :p-error-list="pErrorList"-->
<!--                    :p-src="pSrc"-->
<!--                    :p-src-id="pSrcId"-->
<!--                    p-select-container="#bsMediaPlanTargetSaveFormDialog"-->
<!--                    p-input-name="dataForm.data.timelineText"-->
<!--                    p-error-key="dataForm.data.timelineText"-->
<!--                    :p-required="true">-->
<!--                </media-plan-target-timeline-select>-->
              <input type="hidden"
                     v-model="data.timelineText"
                     name="dataForm.data.timelineText"/>
<!--              </div>-->
            </div>
          </div>
          <div class="modal-footer">
            <div class="text-right">
              <button type="submit" class="btn btn-primary">
                <i class="fa-light fa-check"></i> <span>{{ pDictionary['dictionary.actions.save'] }}</span>
              </button>
              <a href="#"
                 class="btn btn-link" data-dismiss="modal" aria-label="Cancel">{{ pDictionary['dictionary.actions.cancel'] }}</a>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import BaseMixin from "@/mixins/base-mixin";
import FormMixin from "@/mixins/form-mixin";
import FormatMixin from "@/mixins/format-mixin";
import refHelpers from "@/helpers/ref-helpers";

export default {
  name: "MediaPlanTargetSaveForm",
  components: {},
  mixins: [BaseMixin, FormMixin, FormatMixin],
  props: {
    pDataForm: Object
  },
  data: function () {
    return {
      data: this.pDataForm.data,
      mediaPlanId: refHelpers.getFirstRefId(this.pDataForm.data.mediaPlanRefs, null),
      errorList: []
    }
  },
  methods: {
    isIdValid: function () {
      return this.data.id !== undefined
             && this.data.id > 0;
    }
  },
  computed: {
    title: function () {
      return this.isIdValid()
             ? this.pDictionary['dictionary.media.plan.target.udate.title']
             : this.pDictionary['dictionary.media.plan.target.create.title'];
    }
  },
  mounted: function () {
    let _component = this;

    let $bsMediaPlanTargetSaveFormDialog = $(this.$refs.bsMediaPlanTargetSaveFormDialog);
    $bsMediaPlanTargetSaveFormDialog.on('shown.bs.modal', function () {

    });

    $bsMediaPlanTargetSaveFormDialog.on('hidden.bs.modal', function () {

    });

    $(_component.$refs.bsMediaPlanTargetSaveFormDialog).modal();
  }
}
</script>

<style scoped>

</style>